<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="GP vs Cost" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            icon="cloud_download"
            color="primary"
            text="Excel"
            class="hide-on-print"
            :block="true"
            @click="handleExport2Excel"
          />
        </template>
      </SimplePageHeader>
      <GPToCostReportFilters
        class="px-5 mb-sm-5"
        @search="handleSearch"
        @clear="handleSearch"
      ></GPToCostReportFilters>
    </div>
    <GPToCostReportTable
      :gpVSCostItems="gpVSCostItems"
    >
    </GPToCostReportTable>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import GPToCostReportFilters from './GPToCostReportFilters'
import GPToCostReportTable from './GPToCostReportTable'
import { SimplePageHeader } from '@/components/pageComponents'
import excel from '@/lib/export/excel'
import { formatCurrency } from '@/lib/display'
import { progresModlaCommands } from '@/lib/progressModal'

export default {
  mixins: [
    progresModlaCommands
  ],
  components: {
    BottomSpacer,
    GPToCostReportFilters,
    GPToCostReportTable,
    SimplePageHeader,
    ButtonCustomIcon
  },
  computed: {
    ...mapFields('gpToCostReport', [
      'gpVSCostItems'
    ])
  },
  methods: {
    ...mapActions('gpToCostReport', [
      'getFieldsWithFilters'
    ]),
    handleSearch () {
      this.getFieldsWithFilters()
    },
    handleExport2Excel () {
      if (this.gpVSCostItems &&
        this.gpVSCostItems.length > 0) {
        let data = []
        let title = ['Employee Name']
        let key = ['employeeName']
        let month = this.year < new Date().getFullYear() ? 12 : new Date().getMonth() + 1
        for (let i = 1; i <= month; i++) {
          switch (i) {
            case 1:
              title.push('January')
              key.push('january')
              break
            case 2:
              title.push('February')
              key.push('february')
              break
            case 3:
              title.push('March')
              key.push('march')
              break
            case 4:
              title.push('April')
              key.push('april')
              break
            case 5:
              title.push('May')
              key.push('may')
              break
            case 6:
              title.push('June')
              key.push('june')
              break
            case 7:
              title.push('July')
              key.push('july')
              break
            case 8:
              title.push('August')
              key.push('august')
              break
            case 9:
              title.push('September')
              key.push('september')
              break
            case 10:
              title.push('October')
              key.push('october')
              break
            case 11:
              title.push('November')
              key.push('november')
              break
            case 12:
              title.push('December')
              key.push('december')
              break
          }
        }
        title.push(...['YTD GP', 'Projected', 'Seat Cost', 'Seat Revenue'])
        key.push(...['ytdGP', 'projected', 'seatCost', 'seatRevenue'])
        for (let entry of this.gpVSCostItems) {
          let row = {
            employeeName: entry.employeeName
          }
          for (let i = 1; i <= month; i++) {
            switch (i) {
              case 1:
                row.january = formatCurrency(entry.january)
                break
              case 2:
                row.february = formatCurrency(entry.february)
                break
              case 3:
                row.march = formatCurrency(entry.march)
                break
              case 4:
                row.april = formatCurrency(entry.april)
                break
              case 5:
                row.may = formatCurrency(entry.may)
                break
              case 6:
                row.june = formatCurrency(entry.june)
                break
              case 7:
                row.july = formatCurrency(entry.july)
                break
              case 8:
                row.august = formatCurrency(entry.august)
                break
              case 9:
                row.september = formatCurrency(entry.september)
                break
              case 10:
                row.october = formatCurrency(entry.october)
                break
              case 11:
                row.november = formatCurrency(entry.november)
                break
              case 12:
                row.december = formatCurrency(entry.december)
                break
            }
          }
          row.ytdGP = formatCurrency(entry.yearToDateGrossProfit)
          row.projected = formatCurrency(entry.projectedGrossProfit)
          row.seatCost = formatCurrency(entry.seatCost)
          row.seatRevenue = formatCurrency(entry.seatRevenue)
          data.push(row)
        }
        const params = {
          title: title,
          key: key,
          data: data,
          autoWidth: true,
          filename: `GPvsCost`
        }
        excel.exportArray2Excel(params)
      }
    }
  },
  created () {
    this.handleSearch()
  }
}
</script>
